<template>
    <div class="splash-wrapper flex absolute w-full h-full gradient-bg">
        <div
            class="flex flex-column justify-content-center w-full align-items-center"
        >
            <div class="flex flex-column align-items-center splash-content">
                <img
                    :src="splashLogo"
                    alt="Emitus"
                    loading="eager"
                    fetchpriority="high"
                    decoding="async"
                />
                <div
                    class="flex align-items-center splash-label relative w-full"
                >
                    <p>Private chat for</p>
                    <Transition name="flip" mode="out-in">
                        <span class="rotating-item" :key="rotateValue">{{
                            rotateValue
                        }}</span>
                    </Transition>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import splashLogo from '@/assets/images/brand/Wispal.svg'
import { ref } from 'vue'

const rotateValue = ref('influencers')

// Rotating words for splash screen, tailored to Wispal's unique value proposition and target users
const words = [
    'influencers', // Social media personalities with large followings
    'niche creators', // Privacy-focused, exclusive, or specialized creators
    'coaches', // Experts offering 1:1 advice and mentorship
    'fans', // High-value clients seeking real connection
]
let wordIndex = 0

setInterval(() => {
    rotateValue.value = words[wordIndex]
    wordIndex = (wordIndex + 1) % words.length
}, 1000)
</script>

<style scoped>
.splash-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1002;
}

.gradient-bg {
    background: linear-gradient(240deg, #6e3dea 20%, #9a55f2 100%);
}

.splash-content img {
    width: 213px;
}

.splash-content div {
    width: 290px;
}

.splash-label {
    font-family: 'Basier Circle';
    font-size: 17px;
    color: #ffffff;
    text-align: left;
    margin-top: 5px;
    letter-spacing: -1px;
}

.flip-enter-active,
.flip-leave-active {
    transition: 0.3s linear;
}

.flip-enter-from {
    opacity: 0;
    transform: translateY(10px);
}

.flip-leave-to {
    opacity: 0;
    transform: translateY(-10px);
}

.rotating-item {
    backface-visibility: hidden;
    margin-left: 4px;
}

/** Fade out splash screen */

.v-leave-active {
    transition: opacity 0.5s;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
</style>
